
import React from 'react';

interface TabNavigationProps {
  activeTab: string;
  setActiveTab: (tab: any) => void;
  tabs: Array<{id: string, label: string}>;
}

const TabNavigation: React.FC<TabNavigationProps> = ({ activeTab, setActiveTab, tabs }) => {
  return (
    <div className="flex border-b border-gray-200 dark:border-gray-700 mb-2">
      {tabs.map(tab => (
        <button
          key={tab.id}
          className={`px-3 py-1 text-xs ${activeTab === tab.id ? 'border-b-2 border-blue-500 font-medium' : 'text-gray-500'}`}
          onClick={() => setActiveTab(tab.id)}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
};

export default TabNavigation;
